import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Reusable brand header used on Practice Zone, Lobby, Parent Portal, Registration,
 * Results, Certificate, and the Admin Login page. Keeps the brand block on the LEFT
 * and a "Back to home" button on the RIGHT — consistent everywhere.
 *
 * Props:
 *   backTo    — route to navigate to when the back link is clicked (default '/')
 *   backLabel — label for the back button (default 'Back to home')
 *   showBack  — show/hide the back link (default true)
 */
const BrandHeader = ({ backTo = '/', backLabel = 'Back to home', showBack = true }) => {
  const navigate = useNavigate();
  return (
    <header className="px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between border-b border-[#e2e8f0] bg-white">
      <div className="flex items-center gap-2.5">
        <img src="/logo.png" alt="Brain Gym Jr." className="w-10 h-10 sm:w-11 sm:h-11 object-contain" />
        <div>
          <h1 className="text-sm sm:text-base font-bold text-[#0f172a] leading-tight" style={{ fontFamily: 'Fredoka, sans-serif' }}>Brain Gym Jr.</h1>
          <p className="text-[10px] sm:text-xs text-[#64748b] -mt-0.5">Olympiad</p>
        </div>
      </div>
      {showBack && (
        <button
          onClick={() => navigate(backTo)}
          className="flex items-center gap-1.5 text-xs sm:text-sm text-[#64748b] hover:text-[#2565eb] font-medium transition-colors px-2.5 py-1.5 rounded-full hover:bg-[#f8fafc]"
          data-testid="brand-header-back-btn"
        >
          <ArrowLeft className="w-4 h-4" /> {backLabel}
        </button>
      )}
    </header>
  );
};

export default BrandHeader;
